export default function processSurcharge(
  rawSurcharge: RawSurcharge,
): Surcharge {
  return {
    amount: rawSurcharge.SurchargeAmount,
    type: rawSurcharge.SurchargeType,
    description: rawSurcharge.SurchargeDescription,
  };
}
